var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 259,
    viewBox: "0 0 259 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.557 89.6003C176.332 86.8253 180.832 86.8253 183.607 89.6003L185.872 91.8658C187.362 93.3557 187.362 95.7713 185.872 97.2612L111.447 171.687C109.957 173.176 107.541 173.176 106.051 171.687L101.459 167.094C99.9691 165.604 99.9691 163.189 101.459 161.699L173.557 89.6003Z",
    fill: "#81FE9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4751 141.68C72.6897 138.915 72.6729 134.416 75.4376 131.63L77.6946 129.356C79.1789 127.861 81.5945 127.852 83.09 129.336L115.667 161.671C117.162 163.156 117.172 165.571 115.687 167.067L111.112 171.676C109.628 173.172 107.212 173.181 105.716 171.696L75.4751 141.68Z",
    fill: "#81FE9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.17706c07c09967bec82e59ed0cdb54e8.svg";
export { ForwardRef as ReactComponent };